import type { i18n as I18n } from 'i18next'

/**
 * The tab title and meta description in the interface language. public/index.html keeps the
 * English ones for crawlers and link previews; this replaces them once the strings have loaded and
 * again on every language switch.
 */
export const applyDocumentTitle = (i18n: Pick<I18n, 't'>) => {
  if (typeof document === 'undefined') return
  document.title = i18n.t('common:meta.title')
  const description = document.querySelector('meta[name="description"]')
  if (description) description.setAttribute('content', i18n.t('common:meta.description'))
}

/** Keeps the document title in the interface language from now on. */
export const followDocumentTitle = (i18n: I18n) => {
  i18n.on('languageChanged', () => applyDocumentTitle(i18n))
  if (i18n.isInitialized) applyDocumentTitle(i18n)
}
